export default function formatTimestamp(timestamp) {
  
  if (!timestamp) {
    return '-'  // placeholder for null/empty
  }
 return new Date(timestamp).toLocaleString('en-US', {
  timeZone: 'UTC',
  hour12: false,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit'
});

}

